/**
 * Brug tussen de NoNonsense-cookiebanner en Shopify's Customer Privacy API.
 *
 * WAAR DIT HOORT
 * In het theme, in theme.liquid, vlak ná het widget.js-script van NNconsent
 * en zo hoog mogelijk in de <head>. Niet in GTM.
 *
 * WAAROM DIT NODIG IS
 * De banner draait op de winkelpagina; GTM draait in de sandbox van de Shopify
 * Custom Pixel. Die twee delen geen dataLayer en zien elkaars variabelen niet.
 * NNconsent stuurt zijn Consent Mode-update dus naar een dataLayer waar onze
 * GTM niet bij kan, en zonder brug blijft alles in de pixel op denied staan.
 *
 * De omweg via Shopify lost dat in één keer op:
 *
 *   banner -> setTrackingConsent() -> Shopify -> visitorConsentCollected
 *          -> onze pixel -> gtag consent update -> GTM
 *
 * Bijkomend voordeel: Shopify onthoudt de keuze shop-breed, dus hij geldt ook
 * in de checkout, waar het theme niet draait. En Shopify's eigen tracking en
 * app-pixels respecteren hem daarmee ook.
 *
 * NNconsent dispatcht geen event bij een keuze, vandaar dat hieronder de
 * opslag wordt gevolgd in plaats van een listener.
 */
(function () {
  var OPSLAG_SLEUTEL = "nn_consent";
  var laatstVerstuurd = null;

  function lees() {
    try {
      var ruw = window.localStorage.getItem(OPSLAG_SLEUTEL);
      if (!ruw) return null;
      var data = JSON.parse(ruw);
      // NNconsent bewaart de keuzes als vlaggen per categorie; afhankelijk van
      // de versie staan ze op het hoogste niveau of onder "choices".
      var keuzes = data.choices || data.categories || data;
      return {
        analytics: Boolean(keuzes.analytics),
        marketing: Boolean(keuzes.marketing),
        preferences: Boolean(keuzes.preferences),
      };
    } catch (e) {
      return null;
    }
  }

  function stuurNaarShopify(keuzes) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || !api.setTrackingConsent) return false;

    api.setTrackingConsent(
      {
        analytics: keuzes.analytics,
        marketing: keuzes.marketing,
        preferences: keuzes.preferences,
        // Alleen relevant voor Amerikaanse privacywetgeving. Gelijk aan
        // marketing houden is het veiligst: wie geen marketing toestaat, wil
        // ook geen doorverkoop.
        sale_of_data: keuzes.marketing,
      },
      function () {
        console.info("[nn-brug] consent doorgegeven aan Shopify:", keuzes);
      }
    );
    return true;
  }

  function verwerk() {
    var keuzes = lees();
    if (!keuzes) return;

    var vingerafdruk = JSON.stringify(keuzes);
    if (vingerafdruk === laatstVerstuurd) return;

    if (stuurNaarShopify(keuzes)) laatstVerstuurd = vingerafdruk;
  }

  function start() {
    verwerk();
    // NNconsent geeft geen signaal bij een keuze, dus volgen we de opslag.
    // Twee seconden lang vaak genoeg om de eerste klik direct op te pikken,
    // daarna rustig doortikken voor een keuze die later wordt aangepast.
    var tot = Date.now() + 2000;
    var snel = setInterval(function () {
      verwerk();
      if (Date.now() > tot) {
        clearInterval(snel);
        setInterval(verwerk, 1000);
      }
    }, 100);

    // Een andere tab die de keuze wijzigt.
    window.addEventListener("storage", function (e) {
      if (e.key === OPSLAG_SLEUTEL) verwerk();
    });
  }

  function laadApiEnStart() {
    // De Customer Privacy API is er niet altijd meteen; Shopify laadt hem op
    // verzoek. Zonder deze stap mislukt setTrackingConsent stilzwijgend.
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (fout) {
        if (fout) {
          console.error(
            "[nn-brug] consent-tracking-api kon niet laden; consent bereikt de " +
              "pixel niet en alle tags blijven geblokkeerd.",
            fout
          );
          return;
        }
        start();
      }
    );
  }

  /**
   * window.Shopify wordt gezet door de content_for_header-tag van het theme.
   * Staat dit script daarboven — wat makkelijk gebeurt, want de banner hoort
   * juist zo hoog mogelijk — dan bestaat het op dit moment nog niet. Wachten
   * in plaats van opgeven scheelt bij elke klant het uitzoeken van de juiste
   * plek in het theme.
   *
   * LET OP: dit bestand komt in een .liquid-bestand terecht. Gebruik hier
   * nooit accolades in Liquid-vorm, ook niet in commentaar of een string:
   * Shopify vervangt die door hun inhoud, midden in de JavaScript, en dan
   * belandt de rest van het script als zichtbare tekst op de pagina.
   */
  var pogingen = 0;
  (function wachtOpShopify() {
    if (window.Shopify && window.Shopify.loadFeatures) {
      laadApiEnStart();
      return;
    }
    if (pogingen++ > 100) {
      console.warn(
        "[nn-brug] window.Shopify.loadFeatures is na 10 seconden nog niet " +
          "beschikbaar. Draait dit script wel in theme.liquid van een " +
          "Shopify-winkel, en staat de content_for_header-tag in de head?"
      );
      return;
    }
    setTimeout(wachtOpShopify, 100);
  })();
})();
